import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';

/**
 * TODO: そもそも発注機能自体をバックエンドに持っていくので、そこで内包されたらこれは消す
 * 発注/未発注フラグをtrueにする
 */
export class UpdateOutputFlagUseCase {
  /**
   * 発注/未発注フラグをtrueにする
   * @param repository - リポジトリ
   * @param orderIds - 発注ID
   */
  public async Execute(repository: OrderRepository, orderIds: string[]): Promise<INetworkResult<string[], Error>> {
    try {
      const response = await repository.updateOutputFlag({
        orderIds: orderIds,
      });
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }
      return {
        status: {
          type: 'success',
          data: [],
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
